import React, { FC, useCallback } from 'react'
import { Dropdown, Menu, Button } from 'antd'
import languageList from '@/i18n/languageList'
import type { MenuInfo } from 'rc-menu/lib/interface'
interface HeaderDropdownProps {
  language: string
  onLanguageChange: (language: string) => void
}

const HeaderDropdown: FC<HeaderDropdownProps> = ({ language, onLanguageChange }) => {
  const onMenuClick = useCallback(
    (event: MenuInfo) => {
      const { key } = event
      onLanguageChange(key)
    },
    [onLanguageChange]
  )

  const menu = (
    <Menu selectedKeys={[language]} onClick={onMenuClick}>
      {languageList.map(item => (
        <Menu.Item key={item.value}>{item.label}</Menu.Item>
      ))}
    </Menu>
  )

  const languageLabel = (languageList.find(item => item.value === language) || {}).label

  return (
    <Dropdown overlay={menu}>
      <Button size="small">{languageLabel}</Button>
    </Dropdown>
  )
}
export default HeaderDropdown
